var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCameraCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_223)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 23C1 10.8497 10.8497 1 23 1C35.1503 1 45 10.8497 45 23C45 35.1503 35.1503 45 23 45C10.8497 45 1 35.1503 1 23Z",
    stroke: "#E8E7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2827 29.7173C16.6596 30.0942 17.2724 30.0942 17.6494 29.7173L23 24.3667L28.3506 29.7173C28.7276 30.0942 29.3404 30.0942 29.7173 29.7173C30.0942 29.3404 30.0942 28.7276 29.7173 28.3506L24.3667 23L29.7173 17.6494C30.0942 17.2724 30.0942 16.6596 29.7173 16.2827C29.3404 15.9058 28.7276 15.9058 28.3506 16.2827L23 21.6333L17.6494 16.2827C17.2724 15.9058 16.6596 15.9058 16.2827 16.2827C15.9058 16.6596 15.9058 17.2724 16.2827 17.6494L21.6333 23L16.2827 28.3506C15.9058 28.7276 15.9058 29.3404 16.2827 29.7173Z",
    fill: "#2E2D2D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraCancel);
export default __webpack_public_path__ + "static/media/ic-camera-cancel.e5da28424ed3ac5f3d1b21c0306507e6.svg";
export { ForwardRef as ReactComponent };